<template>
    <span>
        <input ref="slider" />
    </span>
</template>

<script>
    import $ from 'jquery'
    
    export default {
        name: "bootstrap-slider",
        created (){
            const vm = this;
            
            const {min, max} = vm.sliderOptions;
            
            //Ensure our value does not exceed the maximum/is below the minimum
            vm.newValue = Math.max(Math.min(vm.value, max), min);
            
            //In case our value changed; immediately let the parent component know
            if(vm.newValue !== vm.value){
                vm.changeValue();
            }
        },
        mounted () {
            const vm = this;

            const slider = $(vm.$refs.slider);
            const options = vm.sliderOptions;

            slider.slider(options);
            slider.slider('setValue', vm.newValue);
            
            slider.slider().on('change', function () {
                vm.newValue = slider.slider('getValue');
                vm.changeValue();
            });
            
            vm.slider = slider.data('slider');
        },
        methods: {
            changeValue() {
                if(this.value !== this.newValue){
                    this.$emit('change-value', this.newValue);
                }
            }
        },
        watch:{
            value(newValue, oldValue){
                const vm = this;
                
                //Value changed by external force
                if(newValue !== oldValue){
                    vm.slider.setValue(newValue);
                }
            }
        },
        data() {
            return {
                newValue: null,
                slider: null
            }
        },
        computed: {
            sliderOptions(){
                const vm = this;
                const options = vm.options || {};
                
                options.min = options.min || 0;
                options.max = options.max || 100;
                
                return options;
            }
        },
        props: {
            value: {
                type: Number,
                required: true
            },
            options: {
                type: Object,
                required: false,
                default: function () {
                    return { min: 0, max: 100 }
                }
            }
        }
    }
</script>

<style scoped>


</style>